import { Country } from '@shared/domain/country/country.aggregate';
import { countryService } from '@shared/domain/country/country.service';
import { httpClient } from '@shared/infrastructure/http/http';
import { CountryDto, toCountryDomainEntity } from './dto/countryDto';
import { configuration } from 'configuration';

export const countryRepositoryImplementation = {
  getCountries: async (): Promise<Country[]> => {
    const response = await httpClient.get<CountryDto[]>(
      `${configuration.api.baseUrl}/api/countries`
    );
    const domainInstanceCountries = response.map((country: CountryDto) => {
      return countryService.createCountry(toCountryDomainEntity(country));
    });

    return domainInstanceCountries;
  }
};
